<template>
  <div
    class="relative"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <button
      v-if="isHovered && isModerated && isSubscriber"
      class="bg absolute inset-0 rounded-full"
      @click="emit('toggle-role', contact.internalNumber)"
    >
      <wui-icon
        :name="role === 'Moderator' ? 'shieldRemove' : 'shield'"
        class="text-white"
      />
    </button>
    <contact-avatar
      :contact="(contact as Contact)"
      :contact-type="contact.type"
    />
    <div
      data-test="close"
      class="
        absolute right-0 top-0 flex h-[14px] w-[14px] cursor-pointer items-center
        justify-center rounded-full border border-white bg-primary
      "
      @click="emit('remove', contact.id)"
    >
      <wui-icon
        name="clear"
        class="h-2! w-2! text-white"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { WuiIcon } from '@wui/common-library'
import { ConferenceMemberRole } from '@wui/im'
import { computed, ref } from 'vue'

import { ContactAvatar } from '@/entities/contact-avatar'

import { Contact, ExternalContact } from '@/shared/types/api'

const props = defineProps<{
  contact: Contact | ExternalContact
  role?: ConferenceMemberRole
  isModerated?: boolean
}>()

const emit = defineEmits<{
  (event: 'remove', id: string): void;
  (event: 'toggle-role', internalNumber: string): void;
}>()

const isHovered = ref(false)

const isSubscriber = computed(() => 'imLogin' in props.contact && !!props.contact.imLogin)
</script>
<style>
.bg {
  background-color: rgba(0, 0, 0, 0.5)
}
</style>
